import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const SuperadminLogin: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('superadminToken')) {
      navigate('/superadmin/dashboard');
    }
  }, [navigate]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const res = await axios.post('http://localhost:8000/api/superadmin/login', {
        email,
        password
      });

      if (res.data.success) {
        localStorage.setItem('superadminToken', res.data.data.token);
        localStorage.setItem('superadminUser', JSON.stringify(res.data.data.user));
        navigate('/superadmin/dashboard');
      }
    } catch (err: any) {
      setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page" style={{ background: 'radial-gradient(circle at 10% 20%, #1a1a2e 0%, #16213e 100%)' }}>
      <div className="auth-card" style={{ boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)' }}>
        <div className="auth-header">
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>👑</div>
          <h1 className="auth-title" style={{ color: '#006A4E' }}>System Superadmin</h1>
          <p className="auth-desc">Manage tenant schools and platform subscriptions.</p>
        </div>

        {error && (
          <div style={{ padding: '12px', backgroundColor: 'var(--color-danger-light)', color: 'var(--color-danger)', borderRadius: '8px', fontSize: '13px', fontWeight: 500, textAlign: 'center' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: 'var(--text-main)', marginBottom: '8px' }}>Admin Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="admin@system.com"
            />
          </div>

          <div>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: 'var(--text-main)', marginBottom: '8px' }}>Master Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
            />
          </div>

          <button type="submit" className="btn btn-primary" style={{ marginTop: '8px', padding: '14px' }} disabled={isLoading}>
            {isLoading ? <span className="spinner"></span> : 'Access Portal'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SuperadminLogin;
